import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const WithdrawStudentEnrollmentMutation = graphql.persisted(
  "WithdrawStudentEnrollment",
  graphql(`
    mutation WithdrawStudentEnrollment($studentEnrollmentId: ID!) {
      withdrawStudentEnrollment(input: {studentEnrollmentId: $studentEnrollmentId}) {
        studentEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { WithdrawStudentEnrollmentMutation };

export function useWithdrawStudentEnrollment() {
  return useMutation(WithdrawStudentEnrollmentMutation);
}
